import styled from 'styled-components';
import { css, breakpoints } from '../../styles/theme';
import { HomePageOptionsTemplate } from './HomePageOptionsTemplate';
import { rem } from 'polished';

export const HomePageOptionsStyled = styled(HomePageOptionsTemplate)`
    .homepage-headline {
        padding: 1rem;
        font-family: ${({ theme }) => theme.fonts.fontBase};
        text-transform: uppercase;
        background-color: ${({ theme }) => theme.colors.grey4};

        &--main {
            font-weight: ${({ theme }) => theme.fontWeights.textBold};
        }

        &--sub {
            font-weight: ${({ theme }) => theme.fontWeights.textRegular};
        }
    }

    .container {
        max-width: ${rem('1200px')};
        margin: 0 auto;
    }

    .homepage-optionCard--wrapper {
        /*  copy paste to change split color bg on other brands first color is top, secong on bottom */
        ${({ theme }) =>
            css`
                background: linear-gradient(-180deg, ${theme.colors.grey4} 40%, ${theme.colors.grey3} 40%);
            `}
        width: 100%;
        min-height: 500px;
        padding: ${rem('10px')};
        display: flex;
        justify-content: center;
        align-items: center;
        flex-direction: column;

        @media (min-width: ${breakpoints.sm}px) {
            flex-direction: row;
        }
    }
`;
